import { useCallback, useEffect, useState } from 'react';

import gallerySubscriptionService from '@/services/gallerySubscription.service';

export default function useGallerySubscription(isGallery) {
  const [gallerySubscription, setGallerySubscription] = useState(null);
  const [galleryLoading, setGalleryLoading] = useState(false);
  const [galleryError, setGalleryError] = useState(null);
  const [gallerySubscriptionVersion, setGallerySubscriptionVersion] = useState(0);
  const [galleryConfig, setGalleryConfig] = useState(null);
  const [galleryConfigError, setGalleryConfigError] = useState(null);
  const [galleryConfigLoading, setGalleryConfigLoading] = useState(false);
  const [galleryCheckoutPrice, setGalleryCheckoutPrice] = useState(null);

  useEffect(() => {
    if (!isGallery) {
      setGallerySubscription(null);
      setGalleryLoading(false);
      setGalleryError(null);
      return undefined;
    }
    let mounted = true;
    setGalleryLoading(true);
    setGalleryError(null);
    setGallerySubscription(null);
    gallerySubscriptionService.getMine()
      .then(({ response, data }) => {
        if (!mounted) return;
        if (response?.ok && data) setGallerySubscription(data);
        else {
          setGalleryError(data?.message ?? 'Unable to load gallery subscription.');
          setGallerySubscription(null);
        }
      })
      .catch((error) => mounted && setGalleryError(error?.message ?? 'Unable to load gallery subscription.'))
      .finally(() => mounted && setGalleryLoading(false));
    return () => { mounted = false; };
  }, [isGallery, gallerySubscriptionVersion]);

  useEffect(() => {
    if (!isGallery) {
      setGalleryConfig(null);
      setGalleryConfigError(null);
      setGalleryConfigLoading(false);
      return undefined;
    }
    let mounted = true;
    setGalleryConfigLoading(true);
    setGalleryConfigError(null);
    gallerySubscriptionService.getConfig()
      .then(({ response, data }) => {
        if (!mounted) return;
        if (response?.ok) {
          setGalleryConfig(data);
          setGalleryConfigError(null);
        } else setGalleryConfigError(data?.message ?? 'Unable to load gallery subscription price.');
      })
      .catch((error) => mounted && setGalleryConfigError(error?.message ?? 'Unable to load gallery subscription price.'))
      .finally(() => mounted && setGalleryConfigLoading(false));
    return () => { mounted = false; };
  }, [isGallery]);

  const refreshGallerySubscription = useCallback(() => {
    setGallerySubscriptionVersion((value) => value + 1);
  }, []);

  return {
    gallerySubscription, galleryLoading, galleryError, galleryConfig, galleryConfigError,
    galleryConfigLoading, galleryCheckoutPrice, setGalleryCheckoutPrice, refreshGallerySubscription,
  };
}
